module.exports = __webpack_public_path__ + "mana.png?aecf42b4b85cb5ee1c0e393e2661bd20";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/mana.png
// module id = 1128
// module chunks = 2